import React from 'react';
import { Switch } from 'react-router-dom';
import { Helmet } from 'react-helmet';

import './App.css';

import PrivateRoute from 'core/utils/auth/PrivateRoute';
import ModalLayout from './components/layouts/ModalLayout/ModalLayout';
import LoginContainer, { links as loginLinks } from './components/layouts/login/LoginContainer';
import LoggedIn from './components/layouts/LoggedIn';
import UserActivationContainer from 'features/user/UserActivationContainer/UserActivationContainer';
import ForgotPasswordContainer, { links as forgotPassLinks } from 'features/user/ForgotPasswordContainer/ForgotPasswordContainer';
import ResetPasswordContainer, { links as resetPassLinks } from 'features/user/ResetPasswordContainer/ResetPasswordContainer';
import SignupModal from './features/Signup/SignupModal';
import AccountActivationContainer from './features/Account/AccountActivation/AccountActivationContainer';

const App = () => (
  <div className="App">
    <Helmet
      defaultTitle="RadonEasy"
      titleTemplate="%s | RadonEasy"
    >
      <meta charSet="utf-8" />
    </Helmet>

    <Switch>
      <ModalLayout exact center path="/user-activation" component={UserActivationContainer} links={[]} />
      <ModalLayout exact center path="/account-activation" component={AccountActivationContainer} links={[]} />
      <ModalLayout exact path="/login" component={LoginContainer} links={loginLinks} />
      <ModalLayout exact path="/forgot-password" component={ForgotPasswordContainer} links={forgotPassLinks} />
      <ModalLayout exact path="/password-reset" component={ResetPasswordContainer} links={resetPassLinks} />

      <SignupModal exact path="/signup" />

      <PrivateRoute component={LoggedIn} />
    </Switch>
  </div>
);

export default App;



// WEBPACK FOOTER //
// ./src/App.js